import React from 'react';
import "./CadastroInstituicao.css";
import Header from "../../components/features/login/Header";
import TitleModule from '../../components/features/register/TitleModule';
import RegisterProgress from '../../components/features/register/RegisterProgress';
import FormComponent from "../../components/Cadastro-Instituicao/FormComponent";

const TermoCooperacaoPage = () => {
    return (
      <div className="PreenchaDados-Page"> 
        <Header/>
        <div className="CadastroInstituicao-container">
            <TitleModule/>
            <RegisterProgress step={5} title="Cadastre a instituição" icon="apartment"/>
            <FormComponent/>
        </div>
      </div>
    );
  };
  
  export default TermoCooperacaoPage;
  